import { TFunction } from 'i18next';

export enum TimerMenuTab {
  Interval = 'interval',
  Entries = 'entries',
}

export const getTimerMenuTabs = (t: TFunction) => {
  return [
    {
      label: t('Task:TimerMenu.IntervalTab'),
      value: TimerMenuTab.Interval,
    },
    {
      label: t('Task:TimerMenu.EntriesTab'),
      value: TimerMenuTab.Entries,
    },
  ];
};
